@if (!isDatepicker) {
  <app-calendar
    [daysOfWeek]="daysOfWeek"
    [daysOfMonths]="daysOfMonths"
    [months]="months"
    [returnDate]="returnDate"
    [startDayOfWeek]="startDayOfWeek"
    [currentDate]="currentDate"
    [readonly]="field.props.readonly"
    (selectMonth)="selectCalendarMonth($event)"
    (selectAvailableDay)="selectAvailableDay($event)">
  </app-calendar>
}

@if (isDatepicker) {
  <app-datepicker
    [daysOfWeek]="daysOfWeek"
    [currentDate]="currentDate"
    [daysOfMonths]="daysOfMonths"
    [weekNumbers]="weekNumbers"
    [activeDay]="activeDay"
    [selectedMonth]="selectedMonth"
    (selectMonth)="selectDatepickerMonth($event)"
    (closeDatepicker)="closeDatepicker.emit()"
    (selectDate)="selectDate.emit($event)">
  </app-datepicker>
}

<div class="validator show my-3">
  @if (key === 'patient_return_at' && formControl.errors) {
    <span class="error-text">
      {{ 'dental.error.invalid_patient_return_at' | translate }}
    </span>
  }
</div>
